<template>
  <validation-observer ref="observer" tag="div" class="footer-item__news">
    <validation-provider v-slot="{errors}" rules="email" slim>
      <h2 class="footer-item__faq-news-header">
        {{ tStatic('footerNewsletterHeader') }}
        <a :name="tStatic('footerNewsletterAnchor')"></a>
      </h2>

      <div :class="['footer-newsletter', { 'footer-newsletter--has-value': false }]">
        <oie-use-svg svg="mail" class="footer-newsletter__icon"></oie-use-svg>
        <input
          ref="subscribe"
          v-model="email"
          type="email"
          :placeholder="tStatic('footerNewsletterPlaceholder')"
          class="footer-newsletter__input"
          @focus="inputFocus()">

        <button :disabled="errors.length > 0 || email.length === 0" :class="['footer-newsletter__submit-action', { 'footer-newsletter__submit-action--has-value': email.length > 0 }]" @click="subscribeAction()">
          <oie-use-svg svg="caret" class="footer-newsletter__action-icon"></oie-use-svg>
        </button>
      </div>

      <div :class="['input__message']">
        <template v-if="errors.length > 0">
          <template v-for="error in errors">
            <div :key="`newsletter-error-${error}`" class="input__message--error">
              {{ error }}
            </div>
          </template>
        </template>

        <template>
          <div v-if="errorMessage" class="input__message--error">
            {{ errorMessage }}
          </div>
        </template>

        {{ message }}
      </div>
    </validation-provider>
  </validation-observer>
</template>

<script>
import httpService from '@/core/http-service'

export default {
  data: () => ({
    email: '',
    message: null,
    errorMessage: null
  }),
  mounted() {
    if (window.location.hash) {
      var hash = window.location.hash.substring(1)
      if (hash === this.tStatic('footerNewsletterAnchor')) {
        setTimeout(() => { this.$refs['subscribe'].focus() }, 300)
      }
    }
  },
  methods: {
    subscribeAction() {
      httpService.post('newsletter/subscribe', { email: this.email }).then((response) => {
        if(response.data.success) {
          this.message = response.data.information
          setTimeout(() => {
            this.email = ''
            this.message = null
          }, 6000)
        } else {
          this.errorMessage = response.data.information
          setTimeout(() => {
            this.errorMessage = ''
            this.message = null
          }, 6000)
        }
      })
      // detta sätts i success response, tillsammans med timeouten nedan
      // this.message = 'success bro'

      // när det är klart så körs denna efter 5 sekunder och rensar
      // setTimeout(() => {
      //   this.email = ''
      //   this.message = null
      // }, 5000)

      // detta kan sättas i error response, jag antar att vi inte kör timeouten och rensningen vid fel?
      // this.errorMessage = 'some error'
    },
    inputFocus() {
      this.errorMessage = null
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-newsletter {
  position: relative;
  display: flex;
  align-items: center;
  background-color: color(background-white);
  border-radius: other(border-radius);
  overflow: hidden;
  width: 100%;

  @include media(large) {
    max-width: 30rem;
    margin-right: 100px;
  }
}

.footer-newsletter__input {
  flex-grow: 1;
  height: 3.5rem;
  border: none;
  padding: 0 measure(half);

  @include media(medium) {
    height: 4rem;
  }

  &::placeholder {
    @include caption;
    color: color(footer-headline);
  }

  &::-webkit-input-placeholder {
    @include caption;
    color: color(footer-headline);
  }

  &:-ms-input-placeholder {
    @include caption;
    color: color(footer-headline);
  }
}

.footer-newsletter__icon {
  width: 2.125rem;
  height: 1.5625rem;
  margin-left: measure(half);
  color: color(footer-headline);
}

.footer-newsletter__submit-action {
  @include reset-button;
  display: flex;
  justify-content: center;
  height: 4rem;
  padding: measure(half);
  border-radius: 0 0.1875rem 0.1875rem 0;
}

.footer-newsletter__submit-action--has-value {
  opacity: 1;
  background-color: color(button-action-green);
}

.footer-newsletter__submit-action--has-value:disabled {
  opacity: .6;
}

.footer-newsletter__submit-action--has-value .footer-newsletter__action-icon {
  color: white;
}
</style>
